import { ID, isServer, Optional } from 'lib'
import { getCookie, setCookie } from 'services/common/Cookies'

export const PERSISTED_ID_COOKIE = 'fc_persistedId'

/**
 * Keeps a cookie that has no dependencies, used for experiements
 */
export const getPersistedId = (): Optional<string> => {
	if (isServer()) return undefined
	let firstLoadCookie = getCookie(PERSISTED_ID_COOKIE)
	if (firstLoadCookie === undefined) {
		firstLoadCookie = ID()
		setCookie(PERSISTED_ID_COOKIE, firstLoadCookie)
	}
	return firstLoadCookie
}
